import classNames from "lib/classNames";
import { ReactElement } from "react";

export default function LetterbookCell({
  children,
  className,
}: {
  children?: ReactElement;
  className?: string;
}) {
  return (
    <td
      className={classNames(
        "p-2 overflow-hidden first:rounded-l-md last:rounded-r-md",
        className || null
      )}
    >
      {children}
    </td>
  );
}
